import { useCallback } from "react";
import updateWalletCurrency from "@/actions/updateWalletCurrency";

const useSetWalletCurrency = (
  walletCurrency: CashierCurrency | undefined,
  currency: CashierCurrency,
) => {
  const setWalletCurrency = useCallback(async () => {
    if (walletCurrency === currency) {
      return;
    }
    updateWalletCurrency(currency);
  }, [currency, walletCurrency]);

  return { setWalletCurrency };
};

export default useSetWalletCurrency;
